/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const ADMIN_CAN_ABILITY = [
  //Route Access
  ["read", "MyProfile"],
  ["read", "DashboardOverview"],
  ["read", "DashboardIssuerAnalysis"],
  ["read", "Masquerader"],
  ["read", "SectionOptionType"],
  ["read", "InventoryTemplate"],
  ["read", "PaymentStatsReport"],
  ["read", "UserList"],
  ["read", "BandRouteLiveMap"],
  ["read", "BandRouteMap"],
  ["read", "BlackListUsers"],
  ["read", "Committe"],
  ["read", "Presentation"],
  ["read", "PresentationAccordian"],
  ["read", "LocalAssetsImport"],
  ["read", "SectionOptionInventoryReport"],
  ["read", "GlobalAssetsImport"],
  ["read", "SectionAssetsImport"],
  ["read", "MasqInvitationWithDiscountTemplate"],
  ["read", "InventoryView"],
  ["read", "InviteCommitteMember"],
  ["read", "Invite"],
  ["read", "InviteMasqueraderPurchase"],
  ["read", "MasqueraderList"],
  ["read", "GenerateDiscount"],
  ["read", "DiscountList"],
  ["read", "CommitteList"],
  ["read", "DiscountCouponList"],
  ["read", "CashierList"],
  ["read", "DeletedBox"],
  ["read", "UpdatedBox"],
  ["read", "DeletedViewBox"],
  ["read", "PresentationList"],
  ["read", "CybersourcePayment"],
  ["read", "PresentationInventory"],
  ["read", "OrgProfile"],
  ["read", "SectionOptionInventory"],
  ["read", "InventoryControl"],
  ["read", "SectionOptionTypeInventory"],
  ["read", "CreateSOTInventory"],
  ["read", "MasqueraderReport"],
  ["read", "PurchasedCostume"],
  ["read", "ViewBoxDetails"],
  ["read", "ViewMasqBoxDetails"],
  ["read", "MasqViewBox"],
  ["read", "MasqBoxList"],
  ["read", "ChangeCostumeOptions"],
  ["read", "SwitchSection"],
  ["read", "SectionBasePriceSummary"],
  ["read", "InventorySummary"],
  ["read", "InventorySummaryDetail"],
  ["read", "InventoryDetailView"],
  ["read", "PaymentFailedFAC"],
  ["read", "CommitteMemberReport"],
  ["read", "DiscountInvite"],
  ["read", "CreateMasqBox"],
  ["read", "ZeroPaymentReport"],
  ["read", "PartialPaymentReport"],
  ["read", "FullPaymentReport"],
  ["read", "DiscountReport"],
  ["read", "SalesReport"],
  ["read", "CommDisList"],
  ["read", "OpenRegister"],
  ["read", "OpenRegisterFlair"],
  ["read", "OpenRegisterElektra"],
  ["read", "OpenRegisterScorch"],
  ["read", "OpenRegisterTravisWorld"],
  ["read", "OpenRegisterEpicCarnival"],
  ["read", "OpenRegisterBattalionMusic"],
  ["read", "OpenRegisterGenx"],
  ["read", "OpenRegisterTriniJungleJuice"],
  ["read", "OpenRegisterIslandCrashers"],
  ["read", "OpenRegisterLil"],
  ["read", "OpenRegisterAbsolute"],
  ["read", "OpenRegisterEnergy"],
  ["read", "OpenRegisterHouseOfBachannal"],
  ["read", "OpenRegisterDLux"],
  ["read", "InventoryControlReport"],
  ["read", "OpenRegisterPunchyPunch"],
  ["read", "OpenRegisterLauraNa"],
  ["read", "OpenRegisterChandraMaharaj"],
  ["read", "OpenRegisterShawnDhanraj"],
  ["read", "OpenRegisterMADJouvert"],
  ["read", "OpenRegisterBikiniCabana"],
  ["read", "OpenRegisterFarmhouse"],
  ["read", "OpenRegisterJCAMFitness"],
  ["read", "OpenRegisterIImagine"],
  ["read", "OpenRegisterKRISP"],
  ["read", "OpenRegisterKristenCamacho"],
  ["read", "OpenRegisterLiveInLove"],
  ["read", "OpenRegisterMarkCorreia"],
  ["read", "OpenRegisterMixedNutz"],
  ["read", "OpenRegisterRoyale"],
  ["read", "OpenRegisterWinerboy"],
  ["read", "OpenRegisterMVP"],
  ["read", "OpenRegisterSolangeGovia"],
  ["read", "OpenRegisterNatalieFonrose"],
  ["read", "OpenRegisterDavidDewer"],
  ["read", "OpenRegisterTribeU"],
  ["read", "OpenRegisterClubhouse"],
  ["read", "OpenRegisterMidnight"],
  ["read", "OpenRegisterMarieange"],
  ["read", "OpenRegisterLivinLocal"],
  ["read", "OpenRegisterDean"],
  ["read", "OpenRegisterMonique"],
  ["read", "OpenRegisterGerard"],
  ["read", "OpenRegisterMelissa"],
  ["read", "OpenRegisterLana"],
  ["read", "OpenRegisterGail"],
  ["read", "OpenRegisterDwayne"],
  ["read", "PaymentTransaction"],
  ["read", "ManageOpenRegistration"],
  ["read", "FHPolicy"],
  ["read", "ProfileUpdateStepper"],
  ["read", "AboutMe"],
  ["read", "CostumeInventoryReport"],
  ["read", "SectionOptInvReport"],
  ["read", "CostumeMatrixSummary"],
  ["read", "PaymentReport"],
  ["read", "DeliveredReport"],
  ["read", "InviteesList"],
  ["read", "PrintLabels"],
  ["read", "ScheduleTable"],
  ["read", "ShelfList"],
  ["read", "ScheduleList"],
  ["read", "ShelfDetail"],
  ["read", "BoxDetail"],
  ["read", "OTPTemplate"],
  ["read", "MasqInvitationTemplate"],
  ["read", "DiscountCodeTemplate"],
  ["read", "CommitteeInvitationTemplate"],
  ["read", "MasqDownPaymentTemplate"],
  ["read", "DeletedBoxTemplate"],
  ["read", "AdminInvitationTemplate"],
  ["read", "DiscountInviteTemplate"],
  ["read", "CashierInviteTemplate"],
  ["read", "CostumePurchaseInviteTemplate"],
  ["read", "InvoiceTemplate"],
  ["read", "TransferBoxNewUserTemplate"],
  ["read", "TransferBoxOldUserTemplate"],
  ["read", "CommonEmailVerificationTemplate"],
  ["read", "PreBookInviteTemplate"],
  ["read", "PreBookDownPaymentEmailTemplate"],
  ["read", "PartialRemainderEmailTemplate"],
  ["read", "UnPaidRemainderEmailTemplate"],
  ["read", "CouponReport"],
  ["read", "CreateDiscount"],
  ["read", "CashSupervisorInvitationTemplate"],
  ["read", "SupervisorInvitationTemplate"],
  ["read", "PrebookToActualBoxes"],
  ["read", "RemoveItemEmailTemplate"]
];

export const ADMIN_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
  ["read", "OpenRegistrationCostumePage"],
  ["read", "Costume"],
  ["read", "CostumeOpenReg"],
  ["read", "InviteList"],
  ["read", "Purchase"],
];
